export interface BrowserLocation {
  protocol: string;
  host: string;
}

export interface StorageLike {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem?: (key: string) => void;
}

export interface StorageEventLike {
  key?: string | null;
  newValue?: string | null;
}

export interface WebSocketMessageEventLike {
  data: string;
}

type WebSocketHandler = (event?: unknown) => void;

export interface WebSocketLike {
  close: () => void;
  onopen?: WebSocketHandler | null;
  onclose?: WebSocketHandler | null;
  onerror?: WebSocketHandler | null;
  onmessage?: (event: WebSocketMessageEventLike) => void;
}

type WebSocketConstructor = new (url: string) => WebSocketLike;

interface BrowserWindowLike {
  location?: BrowserLocation;
  localStorage?: StorageLike;
  WebSocket?: WebSocketConstructor;
  addEventListener?: (type: string, listener: (event: StorageEventLike) => void) => void;
  removeEventListener?: (type: string, listener: (event: StorageEventLike) => void) => void;
}

export function getBrowserWindow(): BrowserWindowLike | null {
  if (typeof globalThis === 'undefined') return null;
  return globalThis as unknown as BrowserWindowLike;
}

export function getBrowserLocation(): BrowserLocation | null {
  const browser = getBrowserWindow();
  const location = browser?.location;
  if (!location?.protocol || !location?.host) return null;
  return location;
}

export function getWebSocketConstructor(): WebSocketConstructor | null {
  const browser = getBrowserWindow();
  return browser?.WebSocket ?? null;
}
